import { _ImageType, _UserType } from './staticTypes';

export const APP_NAME = 'OnSolt';
export const DOMAIN_NAME = 'onsolt.app';
// Non-production environments get an env tag before the domain, e.g. `{venue}-staging.onsolt.app`
const DOMAIN_ENV_TAGS: Record<string, string> = { development: '-development', staging: '-staging' };
export const DOMAIN_SUFFIX = `${DOMAIN_ENV_TAGS[(process.env.REACT_APP_ENVIRONMENT ?? '').trim().toLowerCase()] ?? ''}.${DOMAIN_NAME}`;
export const APP_YEAR = new Date().getFullYear();
export const TARGET_LANGUAGE = 'targetLanguage';
export const LANGUAGE_CHANGE_TIME = 'languageChangeTime';

export const ADMIN_ID_HEADER = 'X-Admin-Id';
export const ORG_ID_HEADER = 'X-Organization-Id';
export const TENANT_ID_HEADER = 'X-Tenant-Id';

export const TIME_FORMAT = 'h:mm A';
export const DATE_FORMAT = 'MMM D, YYYY';
export const DATE_TIME_FORMAT = 'MMM D, YYYY, h:mm A';

export const MOBILE_BREAKPOINT = 768;

export const BROADCAST_CHANNEL = 'MLX_BROADCAST_CHANNEL';
export const BROADCAST_MESSAGES = {
    FORCE_LOGOUT: 'FORCE_LOGOUT',
};

export const userTypes: { [key: string]: _UserType } = {
    ADMIN_STAFF: 'adminStaff',
    SUPER_ADMIN: 'superAdmin',
    ORG_ADMIN: 'organizationAdmin',
    ORG_ADMIN_STAFF: 'organizationStaff',
};

export enum AlertVariant {
    SUCCESS = 'success',
    ERROR = 'error',
}

export enum FileType {
    IMAGE = 'image',
    VIDEO = 'video',
}

export const IMAGE_TYPE: _ImageType = {
    LANDSCAPE: { width: 600, height: 400, aspectRatio: 3 / 2 },
    PORTRAIT: { width: 600, height: 400, aspectRatio: 3 / 2 },
    BANNER: { width: 900, height: 300, aspectRatio: 3 / 1 },
    MENU: { width: 600, height: 400, aspectRatio: 3 / 2 },
    BEVERAGE: { width: 600, height: 600, aspectRatio: 1 / 1 },
    FOOD: { width: 600, height: 400, aspectRatio: 3 / 2 },
    INGREDIENT: { width: 600, height: 400, aspectRatio: 3 / 2 },
    NEWS: { width: 600, height: 400, aspectRatio: 3 / 2 },
    EVENTS: { width: 600, height: 400, aspectRatio: 3 / 2 },
    MOBILE_LOGO: { width: 500, height: 500, aspectRatio: 2 / 2 },
    WEB_LOGO: { width: 600, height: 400, aspectRatio: 3 / 2 },
    PROFILE_IMAGE: { width: 150, height: 150, aspectRatio: 2 / 2 },
};

export enum PermissionKeys {
    MANAGE_ORGANIZATION = 'organization',
    MANAGE_ORGANIZATION_PERMISSION = 'organization_permission',
    MANAGE_ORGANIZATION_STAFF = 'organization_staff',
    MANAGE_PERMISSION = 'permission',
    MANAGE_REPORTS = 'reports',
    MANAGE_STAFF = 'staff',
}

export enum SubPermissionKeys {
    ADD_ORGANIZATION = 'add_organizations',
    EDIT_ORGANIZATION = 'edit_organizations',
    DELETE_ORGANIZATION = 'delete_organizations',
    VIEW_ORGANIZATION = 'view_organizations',

    ADD_ORGANIZATION_PERMISSION = 'add_organization_permission',
    EDIT_ORGANIZATION_PERMISSION = 'edit_organization_permission',
    DELETE_ORGANIZATION_PERMISSION = 'delete_organization_permission',
    VIEW_ORGANIZATION_PERMISSION = 'view_organizations_permission',

    ADD_ORGANIZATION_STAFF = 'add_organization_staff',
    EDIT_ORGANIZATION_STAFF = 'edit_organization_staff',
    DELETE_ORGANIZATION_STAFF = 'delete_organization_staff',
    VIEW_ORGANIZATION_STAFF = 'view_organization_staff',

    ADD_PERMISSION = 'add_permission',
    EDIT_PERMISSION = 'edit_permission',
    DELETE_PERMISSION = 'delete_permission',
    VIEW_PERMISSION = 'view_permission',

    VIEW_REPORTS = 'view_reports',

    ADD_STAFF = 'add_staff',
    EDIT_STAFF = 'edit_staff',
    DELETE_STAFF = 'delete_staff',
    VIEW_STAFF = 'view_staff',
}

export enum OrgPermissionKeys {
    MANAGE_VENUE = 'venue',
    MANAGE_VENUE_STAFF = 'venue_staff',
    MANAGE_STAFF = 'staff',
    MANAGE_PERMISSION = 'permission',
    MANAGE_VENUE_SETTINGS = 'venue_settings',
    MANAGE_VENUE_SCHEDULE = 'venue_schedule',
    MANAGE_VENUE_PERMISSION = 'venue_permission',
    MANAGE_VENUE_MENU = 'venue_menu',
}

export enum OrgSubPermissionKeys {
    // Venue
    ADD_VENUE = 'add_venue',
    EDIT_VENUE = 'edit_venue',
    DELETE_VENUE = 'delete_venue',
    VIEW_VENUE = 'view_venue',

    // Venue Staff
    ADD_VENUE_STAFF = 'add_venue_staff',
    EDIT_VENUE_STAFF = 'edit_venue_staff',
    DELETE_VENUE_STAFF = 'delete_venue_staff',
    VIEW_VENUE_STAFF = 'view_venue_staff',

    // Staff
    ADD_STAFF = 'add_staff',
    EDIT_STAFF = 'edit_staff',
    DELETE_STAFF = 'delete_staff',
    VIEW_STAFF = 'view_staff',

    // Permissions
    ADD_PERMISSION = 'add_permission',
    EDIT_PERMISSION = 'edit_permission',
    DELETE_PERMISSION = 'delete_permission',
    VIEW_PERMISSION = 'view_permission',

    // Venue Settings
    ADD_VENUE_SETTINGS = 'add_venue_settings',
    EDIT_VENUE_SETTINGS = 'edit_venue_settings',
    DELETE_VENUE_SETTINGS = 'delete_venue_settings',
    VIEW_VENUE_SETTINGS = 'view_venue_settings',

    // Venue Schedule
    VIEW_VENUE_SCHEDULE = 'view_venue_schedule',

    // Venue Permission
    ADD_VENUE_PERMISSION = 'add_venue_permission',
    EDIT_VENUE_PERMISSION = 'edit_venue_permission',
    DELETE_VENUE_PERMISSION = 'delete_venue_permission',
    VIEW_VENUE_PERMISSION = 'view_venue_permission',

    // Venue Menu
    ADD_VENUE_MENU = 'add_venue_menu',
    EDIT_VENUE_MENU = 'edit_venue_menu',
    DELETE_VENUE_MENU = 'delete_venue_menu',
    VIEW_VENUE_MENU = 'view_venue_menu',
}
